// extracted by mini-css-extract-plugin
module.exports = {"component":"image-gallery-block-controls_component__2wL0d","button":"image-gallery-block-controls_button__qFxYx"};